<template>
  <div class="neterror" ontouchmove="return false">
    <img class="img" :src="pic" />
    <p class="tips">{{tips}}</p>
    <p class="reload" v-if="type==0" @click="retry">重新加载</p>
  </div>
</template>
<script>
const pciList = ['//file.40017.cn/appresource/propublic/base/e_error_new.png', '//file.40017.cn/appresource/propublic/base/e_no_result.png']
export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 0, //0网络异常 1无结果
    },
    tips: {
      type: String,
      default: '网络异常',
    },
  },
  computed: {
    pic() {
      console.log(this.type)
      return pciList[this.type]
    },
  },
  methods: {
    retry() {
      window.location.reload()
    }
  },
};
</script>
<style lang="less" scoped>
.neterror {
  background: #f1f2f3;
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  -webkit-box-orient: vertical;
  .img {
    width: 280px;
    height: 170px;
  }
  .tips {
    padding-top: 18px;
    font-size: 16px;
    line-height: 20px;
    color: #37383d;
  }
  .reload {
    width: 140px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    margin: 20px auto 0;
    background: #324aa3;
    border-radius: 2px;
    line-height: 40px;
    color: #fff;
  }
}
</style>